var o = {};
export {
  o as __exports
};
//# sourceMappingURL=index.es303.js.map
